import { Configuration } from 'common'

export function configurationReducer(state: Configuration): Configuration {
  return state || null
}
